var _style, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "Cardboard_svg__Lager_7",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 32 32"
    },
    viewBox: "0 3 32 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .Cardboard_svg__st0{fill:none;stroke-width:.75;stroke-linecap:round;stroke-linejoin:round}\n  ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m27.2 14.4.1 8.9-9.8 5.4.2-17.3 9.4-2.2",
    className: "Cardboard_svg__st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m14.9 8.8-2.6-2.6L.6 7.8 5.4 11l-3.9 3.9 3.9.7 8.2 1.5 4.1-5.7 4.2 5 5.3-2 4.2-1.5-4.3-3.7 3.2-4.9L18.4 4l-3.5 4.8",
    className: "Cardboard_svg__st0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9 8.8 5.4 11l12.3.4 9.4-2.2-12.2-.4m-9.5 6.8v9.3l12.1 3.8",
    className: "Cardboard_svg__st0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardboard);
export default __webpack_public_path__ + "static/media/Cardboard.d9e377bd82f471a0539352be40f84938.svg";
export { ForwardRef as ReactComponent };